module.exports = __webpack_public_path__ + "img/photon.f59dc63e.svg";